import type { Pathway } from "../../types/pathway.types";
import { ahtDemographicConfiguration } from "./_shared/ahtDemographicBanner";
import { WEIGHT_ASSESSMENT_STEP_TOTAL, WEIGHT_SELECTOR_NODE_ID } from "./_shared/weightFlowSteps";

const OUT_CHAIN = "aht-sel-chain-out";

export const ahtWtSelectorPathway: Pathway = {
  id: "aht-wt-selector",
  name: "Weight Management (AHT)",
  population: "AHT weight management consultation",
  refinedFlowUi: { stepOffset: 0, stepTotal: WEIGHT_ASSESSMENT_STEP_TOTAL },
  pgdRefs: [],
  demographicConfiguration: ahtDemographicConfiguration,
  demographicEligibility: {
    minAge: 12,
    maxAge: 85,
    blockMessage:
      "Weight management medicines under this PGD are only licensed for patients aged 12 up to (but not including) 85 years. Refer to GP or paediatric services.",
  },
  entryNode: WEIGHT_SELECTOR_NODE_ID,

  nodes: [
    {
      id: WEIGHT_SELECTOR_NODE_ID,
      type: "single_select",
      text: "What type of consultation is this?",
      options: [
        { id: "initial",      label: "New patient — first supply", hint: "First supply of a weight management medicine." },
        { id: "transfer",     label: "Transferring from another provider — continuing treatment", hint: "Needs evidence of last dose, strength and date." },
        { id: "reinitiation", label: "Returning patient — restarting treatment", hint: "You'll be asked when the last dose was taken." },
      ],
      routing: {
        initial:      "aht-sel-chain-out",
        transfer:     "aht-sel-chain-out",
        reinitiation: "aht-sel-chain-out",
      },
      storesTo: "aht-sel-consultation-type",
      required: true,
    },
  ],

  outcomes: {
    [OUT_CHAIN]: {
      id: OUT_CHAIN,
      type: "outcome",
      outcomeType: "chain",
      title: "Loading pathway...",
      safetyNetting: [],
      chainId: "aht-wt-selector-chain",
    } as any,
  },
};
